import React, {useEffect, useState} from 'react';
import InspectionTags from '../../components/InspectionTags/InspectionTags';
import NoteIcon from '../../SVG/NoteIcon';
import WiFiIcon from '../../SVG/WiFiIcon';
import WebIcon from '../../SVG/WebIcon';
import {useTranslation} from '../../hooks/useTranslation';

export default function CompletedInspectionTags({item, showNfc}) {
  const {t} = useTranslation();
  const [keys, setKeys] = useState({firstKey: 'no_nfc', secondKey: []});

  const tagsDetails = {
    nfc: {
      icon: <WiFiIcon width='15' height='15' />,
      tooltipText: t('completedInspectionTags.completed'),
      text: 'NFC',
      tagType: 'NFC',
    },
    no_nfc: {
      icon: <WiFiIcon width='15' height='15' color='#DA6767' />,
      tooltipText: t('completedInspectionTags.nfcSkipped'),
      text: 'NFC',
      tagType: 'NO_NFC',
    },
    web: {
      icon: <WebIcon width='17' height='17' />,
      tooltipText: t('completedInspectionTags.completedOnWeb'),
      text: 'WEB',
      tagType: 'WEB',
    },
    note: {
      icon: <NoteIcon width='17' height='17' />,
      tooltipText: item?.beacon_comment || '',
      text: t('completedInspectionTags.note'),
      tagType: 'NOTE',
    },
  };

  useEffect(() => {
    const firstKey = item?.beacon_present ? 'nfc' : 'no_nfc';
    let secondKey = [];

    switch (true) {
      case item?.is_web:
        secondKey = ['web'];
        break;
      case item?.is_mobile && item?.beacon_comment?.length > 0:
        secondKey = ['note'];
        break;
      default:
        secondKey = [];
        break;
    }

    setKeys({firstKey, secondKey});
  }, [item]);

  const renderTag = key => {
    const tag = tagsDetails[key];
    return tag ? (
      <InspectionTags
        key={key} // Ensure unique keys when mapping
        id={`tooltip_${item?.id}_${key}`}
        icon={tag.icon}
        tooltipText={tag.tooltipText}
        text={tag.text}
        tagType={tag.tagType}
      />
    ) : null;
  };

  return (
    <>
      {showNfc && renderTag(keys.firstKey)}
      {!item?.beacon_present && keys.secondKey.map(renderTag)}
    </>
  );
}
